import t from"numeral";Number.prototype.fixFloat=function(t){return parseFloat(this.toFixed(t))},Number.prototype.formatNumeral=function(r){return t(this).format(r)};
